import React from 'react';

// Style
import "./SearchScreen.scss";

// Lib
import { useWindowSize } from 'lib/hooks';

// components
import Tabs from 'components/UiKit/Tabs';
import Structure from './pages/Structure';
import BioSearch from './pages/BioSearch';
import TextSearch from './pages/TextSearch';
import HelmetCeo from 'components/HelmetCeo';
import SearchByListOfIDs from './pages/SearchByListOfIDs';

const configCeo: {[index: string]: string }[] = [
  {
    name: 'robots',
    content: 'index,follow',
  },
  {
    name: 'description',
    content: 'Bio search, target search, protein',
  },
];

export const Search: React.FC = () => {
	const isMobile: boolean = useWindowSize().width <= 560;
	const tabs = [
		{
			url: 'bio-search',
			label: 'Biosearch',
			content: <BioSearch />
		},
		{
			url: 'text-search',
			content: <TextSearch />,
			label: isMobile ? 'Keyword' : 'Search by keyword'
		},
		{
			url: 'search-by-list-of-ids',
			content: <SearchByListOfIDs />,
			label: isMobile ? 'List of IDs' : 'Search by list of IDs'
		},
		{
			url: 'structure',
			content: <Structure />,
			label: isMobile ? 'Structure' : 'Structure search'
		}
	];

	return (<>
		<HelmetCeo data={configCeo} />
		<div className="search-screen">
			<div className="wrapper">
				{isMobile && <p className="search-screen__title-mobile mb10">Search by</p>}
				<Tabs
					tabs={tabs}
					type="primary"
					defaultScreen="name"
				/>
			</div>
		</div>
	</>);
};

export default Search;
